import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconSubtract: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="#fff">
        <path d="m2.0762 2.62325 5.18589 4.84342-5.68232 5.30703c-.992415-1.3325-1.57977-2.98451-1.57977-4.7737 0-2.06997.786163-3.95632 2.0762-5.37675z" />
        <path d="m2.79408 1.92541c1.39921-1.200247 3.21788-1.92541 5.20592-1.92541 1.98538 0 3.8018.723225 5.2003 1.92059l-5.20568 4.86192z" />
        <path d="m13.9189 2.61781-5.19175 4.84886 5.68865 5.31303c.9951-1.3336 1.5842-2.98785 1.5842-4.7797 0-2.07261-.7882-3.96113-2.0811-5.38219z" />
        <path d="m13.7683 13.5432-5.77368-5.39238-5.76799 5.38708c1.45595 1.5175 3.50434 2.4621 5.77337 2.4621 2.2664 0 4.3127-.9424 5.7683-2.4568z" />
      </g>
    </svg>
  </IconStyled>
);

IconSubtract.defaultProps = iconDefaultProps;
IconSubtract.displayName = 'IconSettings';

export default IconSubtract;
